import httpManager from "@/app/shared/utils/httpManager";

export async function downloadPaymentVoucher({ transactionId = 1 } = {}) {
  const url = `/billing/payments/${transactionId}/invoice/download/`;

  const response = await httpManager.getBlob(url);

  return response;
}
